import React from 'react';
import ProvisionClauseTypeDialog from 'src/components/project/sections/ProvisionClauseTypeDialog';
import IndexReferenceType from 'src/models/IndexReferenceType';
import ProvisionClauseType from 'src/models/ProvisionClauseType';

export type dialogCreator = {
    editProvisionClauseType: (
        clientNumber: number,
        projectNumber: number,
        provisionClauseType: ProvisionClauseType,
        provisionValues: IndexReferenceType[],
        provisionUnits: IndexReferenceType[],
        onSave: (updated: ProvisionClauseType) => void
    ) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => ({
    editProvisionClauseType: (clientNumber, projectNumber, provisionClauseType, provisionValues, provisionUnits, onSave) => {
        setDialog(
            React.createElement(ProvisionClauseTypeDialog, {
                clientNumber,
                projectNumber,
                provisionClauseType,
                provisionValues,
                provisionUnits,
                onSave,
            })
        );
    },
});

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/settings.ts